<template>
  <div class="challenge-header">
    <div class="challenge-left">
      <div class="challenge-title">
        {{ title }}
        <span v-if="false" class="live-badge">● LIVE</span>
        <span v-if="challengeStatus == 'CHALLENGE IN PROGRESS'" class="live-badge-v1">
          <span class="dot"></span> LIVE
        </span>
        <span :title="!isInFullScreenMode ? 'Full Screen mode' : 'Exit Full Screen mode'" class="fullscreen-toggle">
          <IconShrink v-if="isInFullScreenMode" size="2rem" color="#FFFFFF" @click="toggleFullScreenMode()" />
          <IconExpand v-else size="2rem" color="#FFFFFF" @click="toggleFullScreenMode()" />
        </span>
      </div>
      <div class="challenge-id">ID: {{ challengeId }}</div>
    </div>

    <div class="challenge-right">
      <div v-if="challengeTimeOver" class="challenge-status">
        {{ challengeStatus }}
      </div>
      <div v-if="!challengeTimeOver" class="timer">
        <div class="timer-icon"></div>
        <span>{{ formattedTime }}</span>
      </div>
      <button v-if="!challengeTimeOver" class="btn btn-primary" @click="hardStop">
        Hard Stop
      </button>
    </div>
  </div>
</template>

<script>
import IconShrink from "@/shared/Controls/Icons/IconShrink.vue";
import IconExpand from "@/shared/Controls/Icons/IconExpand.vue";

export default {
  name: 'ChallengeHeaderV2',
  components: {
    IconShrink,
    IconExpand,
  },
  props: {
    title: {
      type: String,
      default: "",
      required: true
    },
    challengeId: {
      type: String,
      required: true
    },
    startTimeInSeconds: {
      type: Number,
      default: 19350
    }
  },
  data() {
    return {
      remainingTime: this.startTimeInSeconds,
      timerInterval: null,
      challengeStatus: 'CHALLENGE IN PROGRESS',
      challengeTimeOver: false,
      isInFullScreenMode: false
    };
  },
  methods: {
    hardStop() {
      clearInterval(this.timerInterval);
      this.challengeTimeOver = true;
      this.challengeStatus = 'CHALLENGE STOPPED';
      this.$parent.stopChallenge('HARD_STOP');
      this.$parent.saveChallengeResults();
    },
    toggleFullScreenMode() {
      this.isInFullScreenMode = !this.isInFullScreenMode;
      if (this.isInFullScreenMode) {
        document.getElementById("app").requestFullscreen();
      } else {
        document.exitFullscreen();
      }
    }
  },
  computed: {
    formattedTime() {
      const hrs = String(Math.floor(this.remainingTime / 3600)).padStart(2, '0');
      const mins = String(Math.floor((this.remainingTime % 3600) / 60)).padStart(2, '0');
      const secs = String(this.remainingTime % 60).padStart(2, '0');
      return `${hrs}:${mins}:${secs}`;
    },
  },
  mounted() {
    this.timerInterval = setInterval(() => {
      if (this.remainingTime > 0) {
        this.remainingTime--;
      } else {
        console.log("Time's up!");
        clearInterval(this.timerInterval);
        this.challengeTimeOver = true;
        this.challengeStatus = 'CHALLENGE COMPLETED';
        this.$parent.stopChallenge('COMPLETED');
        this.$parent.saveChallengeResults();
      }
    }, 1000);
  },
  beforeUnmount() {
    clearInterval(this.timerInterval);
  }
};
</script>

<style scoped>
.challenge-header {
  margin-left: 1rem;
  margin-right: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  background-color: #0f0f0f;
  color: white;
}

.challenge-left {
  display: flex;
  flex-direction: column;
}

.challenge-title {
  font-size: 2rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 12px;
}

.live-badge-v1 {
  background: #ff4444;
  color: #fff;
  padding: 0.45rem 0.9rem;
  font-size: 0.8rem;
  font-weight: bold;
  border-radius: 999px;
  box-shadow: 0 0 0.8rem rgba(255, 70, 70, 0.6);
  display: flex;
  align-items: center;
  animation: glowPulse 2s infinite;
  letter-spacing: 1px;
}

.live-badge-v1 .dot {
  background: #fff;
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  margin-right: 0.5rem;
  animation: blink 1s infinite;
}

@keyframes blink {

  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }
}

.live-badge {
  background-color: #e74c3c;
  color: white;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: bold;
}

.challenge-id {
  color: #bbb;
  font-size: 1rem;
  margin-top: 0.5rem;
}

.challenge-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.5rem;
}

.challenge-status {
  font-size: 1.2rem;
  color: #aaa;
}

.timer {
  display: flex;
  align-items: center;
  font-size: 2rem;
  font-weight: bold;
  color: #fff;
}

.timer-icon {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  border: 3px solid #1abc9c;
  border-top-color: transparent;
  animation: spin 2s linear infinite;
  margin-right: 10px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
.fullscreen-toggle {
    padding: 0.5rem;
    padding-bottom: 1rem;
    cursor: pointer;
}
</style>
